export default "__VITE_ASSET__CsU51ruj__"